import api from "../../../api";

const API_URL = "/crm/proposal-stages";

// API functions
export const getProposalStages = async () => {
  try {
    const response = await api.get(API_URL);
    return response.data;
  } catch (error) {
    console.error('Error fetching proposal stages:', error);
    throw error;
  }
};

export const createProposalStage = async (data) => {
  try {
    const response = await api.post(API_URL, data);
    return response.data;
  } catch (error) {
    console.error('Error creating proposal stage:', error);
    throw error;
  }
};

export const updateProposalStage = async (id, data) => {
  try {
    const response = await api.put(`${API_URL}/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating proposal stage:', error);
    throw error;
  }
};

export const deleteProposalStage = async (id) => {
  try {
    const response = await api.delete(`${API_URL}/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting proposal stage:', error);
    throw error;
  }
};

export const searchProposalStages = async (query) => {
  try {
    const response = await api.get(`${API_URL}/search?q=${encodeURIComponent(query)}`);
    return response.data;
  } catch (error) {
    console.error('Error searching proposal stages:', error);
    throw error;
  }
};
